import actionType from 'utils/mw/actionType.util';

// noinspection JSUnusedGlobalSymbols
export default actionType('REQUEST_CODE');
